import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ExternalLink, Globe, Loader2 } from 'lucide-react';
import { apiFetch, getAuthHeaders } from '../../../services/http';
import { useSessionStore } from '../../../stores/sessionStore';
import './campaign-destination-preview.css';

interface DestinationPreview {
  url: string;
  title: string;
  description: string;
  image: string | null;
  available: boolean;
  visualSource?: string;
}

export function CampaignDestinationPreview({ campaignId, url }: { campaignId: string; url: string }) {
  const token = useSessionStore(state => state.session?.access_token);
  const tenantId = useSessionStore(state => state.activeTenantId);
  const [failedImage, setFailedImage] = useState<string | null>(null);
  const { data, isPending, isError } = useQuery({
    queryKey: ['campaign', campaignId, 'destination-preview', tenantId, url],
    queryFn: () => apiFetch<DestinationPreview>(`/v1/crm/campaigns/${encodeURIComponent(campaignId)}/destination-preview`, {
      headers: getAuthHeaders(token),
    }),
    enabled: Boolean(token), staleTime: 10 * 60 * 1000, retry: false,
  });
  const image = data?.image && data.image !== failedImage ? data.image : null;
  return <a className="campaign-destination-preview" href={url} target="_blank" rel="noopener noreferrer"
    aria-label={`Abrir destino: ${data?.title || new URL(url).hostname}`}
    onClick={event => event.stopPropagation()}>
    <div className="campaign-destination-visual">
      {image ? <img src={image} alt="Preview da página de destino" loading="lazy" referrerPolicy="no-referrer"
        onError={() => setFailedImage(image)} />
        : isPending ? <Loader2 size={24} className="spin" /> : <Globe size={28} />}
      <span>Preview do destino <ExternalLink size={12} /></span>
    </div>
    <div className="campaign-destination-copy">
      <strong>{data?.title || new URL(url).hostname}</strong>
      {data?.description && <p>{data.description}</p>}
      {(data?.available === false || data?.visualSource === 'unavailable' || failedImage === data?.image || isError)
        && <small>Captura visual indisponível. Abrir página de destino.</small>}
      <span title={url}>{url}</span>
    </div>
  </a>;
}
